const FORMULA_PREFIXES: RegExp = /^[=+\-@|\t\r\n]/;

export function sanitizeCsvValue(value: string): string {
  if (!value) {
    return value;
  }
  return FORMULA_PREFIXES.test(value) ? `\t${value}` : value;
}
